import { array } from 'yup';
import { InitialAssessmentSummaryDataReferredProfessionalSchema } from './InitialAssessmentSummaryDataReferredProfessionalSchema';

// Bug in formik, it does not show formik.errors for arrays
// https://github.com/jaredpalmer/formik/issues/1116
// Use yup validation
export const InitialAssessmentSummaryDataReferredProfessionalListSchema =
  array().of(InitialAssessmentSummaryDataReferredProfessionalSchema).required();
